
export default function ExportCsvButtonDirective() {
    'ngInject';
    return {
        template: require('./export-csv-button.html'),
        transclude: true,
        restrict: 'E'
    };
}
